import { Suspense, useEffect } from "react"
import { useQueryLoader } from "react-relay"
import { LoadingSpinner } from "@/components/loading-spinner"
import { ChatResizableLayoutContent } from "@/modules/chats/components/chat-layout/chat-resizable-layout-content"
import { useChatAppointmentsQuery } from "@/modules/chats/services/__generated__/useChatAppointmentsQuery.graphql"
import { chatAppointmentsQuery } from "@/modules/chats/services/useChatAppointmentsQuery"

export const ChatResizableLayout = () => {
  const [queryReference, loadQuery] = useQueryLoader<useChatAppointmentsQuery>(chatAppointmentsQuery)

  useEffect(() => {
    loadQuery({}, { fetchPolicy: "network-only" })
  }, [loadQuery])

  return (
    <Suspense fallback={<LoadingSpinner isFullPage size={24} />}>
      {queryReference && <ChatResizableLayoutContent queryReference={queryReference} />}
    </Suspense>
  )
}
